import { render, staticRenderFns } from "./EditorBook.vue?vue&type=template&id=04fe71f8&"
import script from "./EditorBook.vue?vue&type=script&lang=js&"
export * from "./EditorBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports